import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button } from '@mui/material';
import axios from 'axios';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useTranslation } from 'react-i18next';



const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
});

const AddCommentModal = ({ open, onClose, topicId, refreshComments }) => {
  const [content, setContent] = useState('');
  const { t } = useTranslation();

  const handleSubmit = async () => {
    const token = localStorage.getItem('token');
    try {
      await api.post(
        `/api/forum/topics/${topicId}/comments`, // Template string düzeltildi
        { content },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      refreshComments(); // Yorumları yeniden yükler
      onClose(); // Modal'ı kapatır
    } catch (error) {
      
    }
  };
  

  return (
    <Dialog open={open} onClose={onClose}>
  <DialogTitle>{t('new_comment')}</DialogTitle>
  <DialogContent>
    <ReactQuill
      value={content}
      onChange={setContent}
      placeholder={t('comment_placeholder')}
      style={{ marginTop: "10px", minHeight: "150px" }}
    />
  </DialogContent>
  <DialogActions>
    <Button onClick={onClose} color="secondary">
      {t('cancel')}
    </Button>
    <Button onClick={handleSubmit} color="primary">
      {t('submit')}
    </Button>
  </DialogActions>
</Dialog>



  );
};

export default AddCommentModal;
